export const FILE_BROWSER_TELEMETRY_EVENT_NAME = {
    DirectoryLoaded: 'DirectoryLoaded',
    DirectorySearchApplied: 'DirectorySearchApplied',
};
export const FILE_BROWSER_INSTANCE = {
    FilespaceBrowser: 'FilespaceBrowser',
    FsEntryPicker: 'FsEntryPicker',
    GuestBrowser: 'GuestBrowser',
    ServiceAccountFilespaceAccess: 'ServiceAccountFilespaceAccess',
};
